var _excluded = ["className", "infos", "index", "onIndexChange", "hasClose", "onClose", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef } from 'react';
import { clamp, classnames } from '@okee-uikit/react-utils';
import { useAutoControlled } from '@okee-uikit/react-hooks';
import { usePrefixCls } from '@okee-uikit/react-config';
import { CloseSmall } from '../../common/icons';
import { PagerSimple } from '../pager/PagerSimple';
export function MultiInfo(props) {
  var _a;

  var className = props.className,
      infos = props.infos,
      index = props.index,
      onIndexChange = props.onIndexChange,
      hasClose = props.hasClose,
      onClose = props.onClose,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      extra = _objectWithoutProperties(props, _excluded);

  var infosRef = useRef(infos);
  infosRef.current = infos;

  var _useAutoControlled = useAutoControlled({
    defaultValue: 0,
    value: index,
    onChange: onIndexChange
  }),
      _useAutoControlled2 = _slicedToArray(_useAutoControlled, 2),
      realIndex = _useAutoControlled2[0],
      setRealIndex = _useAutoControlled2[1];

  var indexRef = useRef(0);
  indexRef.current = realIndex;
  var onCloseRef = useRef();
  onCloseRef.current = onClose;
  var handleClose = useRef(function () {
    var _a;

    (_a = onCloseRef.current) === null || _a === void 0 ? void 0 : _a.call(onCloseRef, indexRef.current);
    setRealIndex(clamp(indexRef.current - 1, 0, infosRef.current.length));
  }).current;
  var handlePageChange = useRef(function (page) {
    setRealIndex(clamp(page - 1, 0, infosRef.current.length));
  }).current;

  var _ref = (_a = infos[realIndex]) !== null && _a !== void 0 ? _a : {},
      content = _ref.content,
      title = _ref.title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type;

  var bodyCls = usePrefixCls('info-multi-body');
  var pagerCls = usePrefixCls('info-multi-pager');
  var closeCls = usePrefixCls('info-body-close');
  var titleCls = usePrefixCls('info-body-title');
  var contentCls = usePrefixCls('info-body-content');
  var cls = classnames(usePrefixCls('info', {
    size: size,
    type: type,
    multi: true
  }), className);
  var closeNode = !!hasClose && React.createElement("span", {
    className: closeCls,
    onClick: handleClose
  }, React.createElement(CloseSmall, null));

  if (!infos.length) {
    return React.createElement(React.Fragment, null);
  }

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    key: "info"
  }), React.createElement("span", {
    className: pagerCls
  }, React.createElement(PagerSimple, {
    showInput: false,
    onPageChange: handlePageChange,
    page: indexRef.current + 1,
    pageSize: 1,
    total: infos.length
  })), React.createElement("span", {
    className: bodyCls
  }, closeNode, !!title && React.createElement("div", {
    className: titleCls
  }, title), !!content && React.createElement("div", {
    className: contentCls
  }, content)));
}